import { render, staticRenderFns } from "./inviteDialog.vue?vue&type=template&id=bc0998f2&scoped=true"
import script from "./inviteDialog.vue?vue&type=script&lang=js"
export * from "./inviteDialog.vue?vue&type=script&lang=js"
import style0 from "./inviteDialog.vue?vue&type=style&index=0&id=bc0998f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0998f2",
  null
  
)

export default component.exports